import axiosInstance from '../lib/axiosInstance';

export const authenticate = async (payload) => {
  return axiosInstance.post('/auth/login', payload);
};

export const register = async (payload) => {
  return axiosInstance.post('/auth/register', payload);
};

export const socialAuthenticate = async (payload) => {
  return axiosInstance.post('/auth/social', payload);
};

export const verifyOTP = async (payload) => {
  return axiosInstance.post('/auth/otp', payload);
};

